import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import {HttpClient, HttpEvent} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import {DeleteFileRequest} from '../_model/request/DeleteFileRequest';
import {ListDocumentRequest} from '../_model/request/ListDocumentRequest';
import {UploadFileRequest} from '../_model/request/UploadFileRequest';

@Injectable({
  providedIn: 'root'
})
export class StorageService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  deleteFile(id: number): Observable<ApiResponse> {
      return this.delete<ApiResponse>('/api/v1/storage/delete/' + id);
  }

  listDocuments(listDocumentRequest: ListDocumentRequest): Observable<ApiResponse> {
      return this.post<ApiResponse>('/api/v1/storage/list', listDocumentRequest);
  }

  uploadDocument(recordId: number, tableName: string, subFolder: string, formData: FormData): Observable<HttpEvent<ApiResponse>> {
        return this.upload<ApiResponse>('/api/v1/storage/upload/' + recordId + '/' + tableName + '/' + subFolder, formData);
  }

}
